<template>
    <b-card title="" class="trigger-card p-2 mb-2" :class="{ 'error-card': !hasEvents }" no-body>
        <template #header class="p-2">
            <div class="d-flex justify-content-between align-items-center w-100">
                <h6 class="text-primary">Send Trigger <b>When</b></h6>
            </div>
        </template>
        <b-card-body class="p-2">
            <div class="readonly-overlay" v-if="readonly"></div>
            <b-collapse visible id="collapse_events">
                <hr class="m-0 mb-3" />

                <b-row class="pl-3 pt-2 pb-2 pr-2 mb-2 mx-lg-5">
                    <div
                        class="condition-string text-primary d-flex align-items-center mb-2"
                        v-for="(eventLabels, i) in eventStringObj"
                        :key="`${eventLabels.source} ${eventLabels.operator} ${eventLabels.target} ${i}`"
                    >
                        <div
                            v-if="eventLabels"
                            class="condition-string-item"
                            :class="{
                                'rounded-left': i === 0,
                                'rounded-right': i === eventStringObj.length - 1,
                            }"
                        >
                            {{ eventLabels.source }}
                            &nbsp; &nbsp;

                            {{ eventLabels.operator }}
                            &nbsp; &nbsp;

                            {{ eventLabels.target }}
                        </div>
                        <div v-if="i !== eventStringObj.length - 1" class="condition-or-item">OR</div>
                    </div>
                </b-row>
                <b-row
                    v-for="(event, i) in events"
                    :key="i"
                    class="flex-wrap justify-content-center justify-content-md-between mb-2 mx-lg-5"
                    :class="{
                        'align-items-inherit': !!getIsRecurringEvent(event.source) || !!getIsDateEvent(event.source),
                        'event-row-align': !getIsRecurringEvent(event.source) && !getIsDateEvent(event.source),
                    }"
                >
                    <b-col
                        class="d-flex justify-content-center mb-md-0 mb-2 align-items-center event-word"
                        v-if="i === 0"
                        md="1"
                    >
                        <b>When</b>
                    </b-col>
                    <b-col
                        class="d-flex justify-content-center mb-md-0 mb-2 align-items-center event-word"
                        md="1"
                        v-else
                        ><span> OR</span></b-col
                    >
                    <b-col md="4">
                        <validation-provider
                            
                            v-slot="{ errors }"
                            :name="getEventVID(event.source, i).source"
                        >
                            <form-dropdown
                                :value="event.source"
                                class="mb-md-0"
                                :options="eventIdentifiers"
                                :isGrouped="true"
                                placeholder="Select Event"
                                @input="(val) => onSelectEvent(val, 'source', i)"
                                :error="errors[0] || getEventError(event.source, 'required')"
                                :disabled="readonly"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="3" v-if="getIsRecurringEvent(event.source)">
                        <validation-provider
                            
                            v-slot="{ errors }"
                            :name="getEventVID(event.source, i).start"
                        >
                            <form-datepicker
                                v-model="event.start"
                                floatingLabel="Start Date"
                                class="mb-md-0 trigger-datepicker"
                                :hide-header="true"
                                placeholder="Start Date"
                                :min="minDate"
                                :display-format="userUnicodeDateFormat"
                                @input="(val) => onChangeValue('start', val, i)"
                                :error="errors[0] || getEventError(event.start, 'required')"
                                :readonly="readonly"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="3" v-if="getIsRecurringEvent(event.source)">
                        <validation-provider  v-slot="{ errors }" :name="getEventVID(event.source, i).until">
                            <form-datepicker
                                floatingLabel="End Date"
                                v-model="event.until"
                                class="mb-md-0 trigger-datepicker w-100"
                                :hide-header="true"
                                placeholder="End Date"
                                :min="getMinEndDate(event)"
                                :display-format="userUnicodeDateFormat"
                                @input="(val) => onChangeValue('until', val, i)"
                                :error="errors[0]"
                                :reset-button="true"
                                :readonly="readonly"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="2" v-if="!getIsRecurringEvent(event.source)">
                        <validation-provider
                            
                            v-slot="{ errors }"
                            :name="getEventVID(event.source, i).operator"
                        >
                            <form-dropdown
                                class="mb-md-0"
                                :value="event.operator"
                                :disabled="!event.source || readonly"
                                placeholder="Select Event Action"
                                :options="getEventOptions(event.source).operator"
                                @input="(val) => onSelectEvent(val, 'operator', i)"
                                :error="errors[0] || getEventError(event.operator, event.source && 'required')"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="4" v-if="getIsDateEvent(event.source)">
                        <validation-provider
                            
                            v-slot="{ errors }"
                            :name="getEventVID(event.source, i).date"
                        >
                            <form-datepicker
                                :value="event.date"
                                class="mb-md-0 trigger-datepicker"
                                :hide-header="true"
                                :min="minDate"
                                :display-format="userUnicodeDateFormat"
                                @input="(val) => onChangeValue('date', val, i)"
                                :error="errors[0] || getEventError(event.date, 'required')"
                                :readonly="readonly"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col md="4" v-if="!getIsRecurringEvent(event.source) && !getIsDateEvent(event.source)">
                        <validation-provider
                            
                            v-slot="{ errors }"
                            :name="getEventVID(event.source, i).target"
                        >
                            <form-dropdown
                                class="mb-md-0"
                                :value="event.target"
                                :options="getEventOptions(event.source).target"
                                :disabled="!event.source || readonly"
                                placeholder="Select Event Status"
                                @input="(val) => onSelectEvent(val, 'target', i)"
                                :error="errors[0] || getEventError(event.target, event.source && 'required')"
                            />
                        </validation-provider>
                    </b-col>
                    <b-col
                        v-show="i !== 0"
                        md="1"
                        class="d-md-flex d-none justify-content-center remove-event-wrapper"
                        :class="{
                            'align-items-center': !!getIsRecurringEvent(event.source) || !!getIsDateEvent(event.source),
                            'event-remove-align': !getIsRecurringEvent(event.source) && !getIsDateEvent(event.source),
                        }"
                    >
                        <b-button
                            @click="removeEvent({ index: i })"
                            class="align-baseline btn-circle-minus"
                            title="Remove"
                            variant="danger"
                            size="xs"
                            v-if="!readonly"
                            ><font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon>
                        </b-button>
                    </b-col>
                    <div
                        v-if="getIsRecurringEvent(event.source)"
                        class="w-100 d-flex justify-content-center mt-2 event-recurring-align"
                        :class="{
                            'event-recurring-align-center': !event.interval,
                        }"
                    >
                        <b-col md="4">
                            <validation-provider
                                v-slot="{ errors }"
                                :name="getEventVID(event.source, i).interval"
                            >
                                <form-input
                                    label="Repeat every:"
                                    class="mb-md-0"
                                    :value="event.interval"
                                    :error="errors[0] || getEventError(event.interval, 'required|validInteger')"
                                    @input="(val) => onChangeValue('interval', val, i)"
                                    :disabled="readonly"
                                />
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider
                                
                                v-slot="{ errors }"
                                :name="getEventVID(event.source, i).freq"
                            >
                                <form-dropdown
                                    class="mb-md-0"
                                    :value="event.freq"
                                    :options="getFreqOptions(event.interval)"
                                    @input="(val) => onChangeValue('freq', val, i)"
                                    :error="errors[0] || getEventError(event.freq, 'required')"
                                    :disabled="readonly"
                                />
                            </validation-provider>
                        </b-col>
                    </div>
                    <div v-if="getIsRecurringEvent(event.source)" class="w-100 d-flex justify-content-center">
                        <b-col md="10" v-if="event.freq === 'MONTHLY'" class="mt-2 mb-2">
                            <validation-provider
                                
                                v-slot="{ errors }"
                                :name="getEventVID(event.source, i).bymonthday"
                            >
                                <form-dropdown
                                    label="Repeat on Day:"
                                    :value="event.bymonthday"
                                    :multiSelect="true"
                                    class="mb-md-0"
                                    :options="monthDayOptions"
                                    :error="errors[0] || getEventError(event.bymonthday, 'required')"
                                    @input="(val) => onChangeValue('bymonthday', val, i)"
                                    :disabled="readonly"
                                />
                            </validation-provider>
                        </b-col>
                        <b-col md="10" v-if="event.freq === 'WEEKLY'" class="mt-2 d-flex">
                            <validation-provider
                                
                                v-slot="{ errors }"
                                :name="getEventVID(event.source, i).byday"
                            >
                                <form-badge-select
                                    label="Repeat on:"
                                    :value="event.byday"
                                    :options="weekdayOptions"
                                    @input="(val) => onChangeValue('byday', val, i)"
                                    :error="errors[0] || getEventError(event.byday, 'required')"
                                    :readonly="readonly"
                                ></form-badge-select>
                            </validation-provider>
                        </b-col>
                        <b-col md="3" v-if="event.freq === 'YEARLY'" class="mt-2">
                            <validation-provider
                                
                                v-slot="{ errors }"
                                :name="getEventVID(event.source, i).bymonth"
                            >
                                <form-dropdown
                                    label="Repeat on:"
                                    :value="event.bymonth"
                                    class="mb-md-0"
                                    :options="monthOptions"
                                    placeholder="Select Month"
                                    @input="(val) => onChangeValue('bymonth', val, i)"
                                    :error="errors[0] || getEventError(event.bymonth, 'required')"
                                    :disabled="readonly"
                                />
                            </validation-provider>
                        </b-col>
                        <b-col md="7" v-if="event.freq === 'YEARLY'" class="mt-2 mb-2">
                            <validation-provider
                                
                                v-slot="{ errors }"
                                :name="getEventVID(event.source, i).bymonthday"
                            >
                                <form-dropdown
                                    label="Day:"
                                    :value="event.bymonthday"
                                    :multiSelect="true"
                                    class="mb-md-0"
                                    :options="yearlyMonthDayOptions(event.bymonth)"
                                    @input="(val) => onChangeValue('bymonthday', val, i)"
                                    placeholder="Select Day"
                                    :error="errors[0] || getEventError(event.bymonthday, 'required')"
                                    :disabled="readonly"
                                />
                            </validation-provider>
                        </b-col>
                    </div>
                    <b-col
                        md="1"
                        class="d-flex d-md-none justify-content-center remove-event-wrapper"
                        :class="{
                            'align-items-start': !!getIsRecurringEvent(event.source) || !!getIsDateEvent(event.source),
                            'event-remove-align': !getIsRecurringEvent(event.source) && !getIsDateEvent(event.source),
                        }"
                    >
                        <b-button
                            @click="removeEvent({ index: i })"
                            class="align-baseline btn-circle-minus"
                            title="Remove"
                            variant="danger"
                            size="xs"
                            v-if="!readonly"
                            ><font-awesome-icon :icon="['fas', 'minus']"></font-awesome-icon>
                        </b-button>
                    </b-col>
                    <b-col class="d-flex d-md-none">
                        <hr class="condition-separator w-100" />
                    </b-col>
                </b-row>

                <hr class="m-0 my-4" />
                <div class="w-100 d-flex justify-content-center">
                    <div @click="addEvent" class="d-flex align-items-center" v-if="!readonly">
                        <b-button class="align-baseline btn-circle-plus mr-1" title="Add" variant="primary" size="xs"
                            ><font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon
                        ></b-button>
                        <span class="text-primary cursor-pointer"> Add Event </span>
                    </div>
                </div>
            </b-collapse>
        </b-card-body>
        <template v-if="!hasEvents" #footer>
            <small class="text-danger">At least one event must be selected</small>
        </template>
    </b-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import parseISO from 'date-fns/parseISO';
    import format from 'date-fns/format';

    import FormInput from '../../../generic/form-input/form-input.vue';
    import FormDropdown from '../../../generic/form-dropdown/form-dropdown.vue';
    import FormBadgeSelect from '../../../generic/form-badge-select/form-badge-select.vue';
    import FormDatepicker from '../../../generic/form-datepicker/form-datepicker.vue';
    import {
        getIsRecurringEvent,
        getIsDateEvent,
        getFreqOptions,
        monthDayOptions,
        monthOptions,
        weekdayOptions,
        yearlyMonthDayOptions,
        generateRecurringString,
    } from '../helpers/helpers';
    import { triggerMixin } from '../mixins/mixin';
    import { OWNER_BLOCK_IDENTIFIER, RECURRING_IDENTIFIER } from '../helpers/constants';

    export default {
        mixins: [triggerMixin],
        components: {
            FormInput,
            FormDropdown,
            FormBadgeSelect,
            FormDatepicker,
        },
        computed: {
            ...mapGetters('trigger', ['events', 'eventIdentifiers', 'eventOptions', 'hasEvents', 'readonly']),
            ...mapGetters('header', ['userUnicodeDateFormat']),
            monthDayOptions,
            weekdayOptions,
            monthOptions,
            eventStringObj() {
                return this.events
                    .map((item) => {
                        return this.getConditionLabelObj(item, false);
                    })
                    .filter((i) => i);
            },
            minDate() {
                const now = new Date();
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
                return format(parseISO(today), 'yyyy-MM-dd');
            },
        },
        methods: {
            generateRecurringString,
            getIsRecurringEvent,
            getIsDateEvent,
            getFreqOptions,
            yearlyMonthDayOptions,
            ...mapActions('trigger', ['removeEvent', 'addEvent']),
            onChangeValue(field, value, i) {
                const events = this.events.map((item, index) => {
                    if (index === i) {
                        if (field === 'freq') {
                            return {
                                ...item,
                                [field]: value,
                                bymonthday: value === 'DAILY' ? ['1'] : [],
                                byday: [],
                                bymonth: null,
                            };
                        }
                        return {
                            ...item,
                            [field]: value,
                        };
                    }
                    return item;
                });
                this.$store.commit('trigger/setEvents', events);
                this.$store.commit('trigger/setEditing', true);
            },
            getMinEndDate(event) {
                return event.start;
            },
            getEventVID(identifier, i) {
                const baseName = `events_store.events.${i}`;
                const idString = `${baseName}.identifier`;
                const targetString = `${baseName}.target`;
                if (
                    [
                        'ARRIVAL_DATE_FUTURE',
                        'ARRIVAL_DATE_PAST',
                        'DEPARTURE_DATE_PAST',
                        'DEPARTURE_DATE_FUTURE',
                    ].includes(identifier)
                ) {
                    return {
                        source: idString,
                        operator: targetString,
                        target: `${baseName}.range_unit`,
                    };
                }
                if (identifier === OWNER_BLOCK_IDENTIFIER) {
                    return {
                        source: idString,
                        operator: targetString,
                        target: `${baseName}.action`,
                    };
                }
                if (identifier === RECURRING_IDENTIFIER) {
                    const baseRecurrence = `${baseName}.recurrence`;
                    return {
                        source: `${baseRecurrence}.identifier`,
                        start: `${baseRecurrence}.start`,
                        until: `${baseRecurrence}.until`,
                        freq: `${baseRecurrence}.freq`,
                        interval: `${baseRecurrence}.interval`,
                        byday: `${baseRecurrence}.byday`,
                        bymonth: `${baseRecurrence}.bymonth`,
                        bymonthday: `${baseRecurrence}.bymonthday.0`,
                    };
                }
                return {
                    source: idString,
                    operator: `${baseName}.action`,
                    target: `${baseName}.status`,
                    date: `${baseName}.date`,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../styles.scss';
</style>
